import React from 'react'
import { Box, Typography, Tab, Tabs } from '@mui/material'
import { makeStyles, withStyles } from 'tss-react/mui'
import { TabbedComponentProps } from '../../types/heroTextSection'
import Image from './Image'
import VideoInsert from './VideoInsert'

interface TabProps {
  list: TabbedComponentProps
}

export const TabbedComponent: React.FC<TabProps> = ({ list }) => {
  const { classes } = useStyles()

  const [tabValue, setTabValue] = React.useState(0)
  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setTabValue(newValue)
  }

  return (
    <Box className={classes.root}>
      <BaseTabs
        value={tabValue}
        onChange={handleChange}
        variant={'fullWidth'}
        centered
        selectionFollowsFocus
        className={classes.tabs}
      >
        {list.imageInsertArray?.map((imageInsert) => (
          <BaseTab
            key={imageInsert.contentful_id}
            aria-labelledby={imageInsert.name}
            // @ts-ignore
            label={<Typography variant="body1">{imageInsert.name}</Typography>}
          />
        ))}
      </BaseTabs>

      <Box className={classes.tabPanel}>
        {list.imageInsertArray?.map((imageInsert, index) => (
          <Box
            key={imageInsert.contentful_id}
            role="tabpanel"
            hidden={tabValue !== index}
            id={imageInsert.contentful_id}
            aria-labelledby={imageInsert.name}
          >
            {tabValue === index &&
              imageInsert.__typename === 'ContentfulImageInsert' && (
                <Image asset={imageInsert.images[0]} />
              )}
            {tabValue === index &&
              imageInsert.__typename === 'ContentfulVideoInsert' && (
                <VideoInsert
                  insert={imageInsert}
                  key={imageInsert.contentful_id}
                />
              )}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

const BaseTabs = withStyles(Tabs, (theme) => ({
  indicator: {
    backgroundColor: theme.palette.action.hover,
    width: '33%',
    [theme.breakpoints.down('md')]: {
      backgroundColor: 'transparent',
    },
  },
  flexContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column' as any,
      borderBottom: 'none',
      outline: 0,
    },
  },
}))

const BaseTab = withStyles(
  (props) => <Tab disableRipple {...props} />,
  (theme) => ({
    root: {
      textTransform: 'none',
      fontWeight: 'normal',
      borderBottom: `2px solid ${theme.palette.divider}`,

      '&:hover': {
        color: theme.palette.action.hover,
        opacity: 1,
      },
      '&.Mui-selected': {
        color: theme.palette.action.hover,
        outline: 0,
      },
      '&:focus': {
        color: theme.palette.action.hover,
      },
      [theme.breakpoints.down('md')]: {
        borderBottom: 'none',
        outline: 0,
      },
    },
    selected: {},
  })
)

const useStyles = makeStyles()((theme) => ({
  root: {
    flexGrow: 1,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '55.44em',
    width: '100%',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  tabs: {
    [theme.breakpoints.down('md')]: {
      paddingTop: '2rem',
    },
  },
  tabPanel: {
    boxShadow: '0 .25em .94em 0 rgba(211, 211, 211, 0.5)',
    height: '31.19em',
    marginTop: '1.875rem',

    [theme.breakpoints.down('md')]: {
      height: '47vw',
      marginTop: '0',
    },
  },
}))

export default TabbedComponent
